import {
  SkeletonLoader,
  SkeletonLoaderProps,
} from '@kanda-libs/ks-design-library';

export type AlternateTextType = {
  text: string;
  type: 'alternate' | 'normal';
};

export interface AlternateTextProps {
  texts: AlternateTextType[];
  normalClassName?: string;
  alternateClassName?: string;
  isLoading?: boolean;
  skeletonProps?: SkeletonLoaderProps;
}

const AlternateText: React.FunctionComponent<AlternateTextProps> = function ({
  texts,
  normalClassName = 'text-16-24',
  alternateClassName = 'text-16-24-em',
  isLoading = false,
  skeletonProps,
}) {
  return (
    <SkeletonLoader
      isLoading={isLoading}
      afterLoading={
        <span>
          {texts.map((text) => {
            if (text.type === 'normal')
              return (
                <span key={text.text} className={normalClassName}>
                  {text.text}{' '}
                </span>
              );
            return (
              <span key={text.text} className={alternateClassName}>
                {text.text}{' '}
              </span>
            );
          })}
        </span>
      }
      {...skeletonProps}
    />
  );
};

export default AlternateText;
